import { motion } from "framer-motion";

export function FloatingSectionNav({ sections }) {
  if (!sections || sections.length === 0) return null;

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      padding: "0 24px",
      marginTop: "-16px",
      marginBottom: "40px",
      position: "relative",
      zIndex: 20,
    }}>
      <div style={{
        display: "flex",
        gap: "10px",
        overflowX: "auto",
        paddingBottom: "4px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}>
        {sections.map((section, i) => (
          <motion.a
            key={section.id}
            href={`#${section.id}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.07, ease: "easeOut" }}
            style={{
              display: "inline-block",
              padding: "8px 20px",
              borderRadius: "999px",
              backgroundColor: "#ffffff",
              color: "#374151",
              fontSize: "13px",
              fontWeight: 600,
              textDecoration: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              whiteSpace: "nowrap",
              transition: "background-color 0.2s, color 0.2s",
            }}
          >
            {section.label}
          </motion.a>
        ))}
      </div>
    </div>
  );
}
